import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TrackerService } from '../../../../../../plugins/tracker/services/tracker.service';

@Component({
  selector: 'project-admin-tracker-delete',
  template: require('./project.admin.tracker.delete.html')
})
export class ProjectAdminTrackerDeleteComponent implements OnInit {
  @Input() tracker: any;

  @Output() onDelete = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();

  isLoading: boolean = false;

  constructor(private trackerService: TrackerService) {}

  ngOnInit(): void {}

  deleteTracker(): void {
    this.isLoading = true;
    this.trackerService.delete(this.tracker)
      .then(() => {
        this.onDelete.emit(this.tracker);
      })
      .catch(() => {
        this.isLoading = false;
        this.onClose.emit();
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  doClose(): void { 
    this.onClose.emit(); 
  }
}
